import * as Sentry from "@sentry/browser";
import { ExtraErrorData, CaptureConsole, HttpClient } from "@sentry/integrations";
import Vue from 'vue';

Sentry.init({
    dsn: process.env.MIX_SENTRY_DSN_PUBLIC,

    tracesSampleRate: 0.8,
    profilesSampleRate: 0.8,

    replaysSessionSampleRate: 0.1,

    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,

    integrations: [
        new Sentry.BrowserTracing(),
        new Sentry.BrowserProfilingIntegration(),
        new Sentry.Replay({
            // Additional SDK configuration goes in here, for example:
            maskAllText: true,
            blockAllMedia: true,
        }),
        new ExtraErrorData({
            depth: 5,
            captureErrorCause: true,
        }),
        new CaptureConsole(),
        new HttpClient({
            failedRequestStatusCodes: [400, 401, 403, 404, 408, 422, 429, 500, 502, 503, 504, 505, 507],
        })
    ],
});

window.Vue = Vue;
Vue.config.performance = true;

window.blobUtil = require('blob-util');

import { loadProgressBar } from './services/axios';

loadProgressBar();

require('../routes');
require('../helpers/index.js');
require('../helpers/sweetAlertCustom.js');

require('./services/addressManager');
require('./inject');
require('./mixins')

require('./directives')
require('./filters')
require('./components');


// const app = new Vue().$mount('#app-vue');

export default Vue;

window.Sentry = Sentry;